import { validators as udValidators } from '@ud/admin-framework'
import { RuleObject } from 'antd/es/form'

let validators = {
  ...udValidators,
  password: (): RuleObject => {
    return {
      pattern: /^(?=.*[a-zA-Z])(?=.*\d)[^]{8,30}$/,
      message: '至少1个大写字母，1个小写字母，1个数字，且不少于8位'
    }
  },
  viewCodeRule:():RuleObject=>{
    return {
      pattern: /[^\u4E00-\u9FA5]+$/,///^[a-zA-Z0-9_-]+$/,//+\(\)*&^%$#@!.,|
      message: '仅可输入英文、英文符号、数字'
    }
  },
  numberAndAlphabe:():RuleObject=>{
    return {
      pattern:/^[a-zA-Z0-9]+$/,
      message:'只能输入字母和数字'
    }
  },
  symbolAlphabe:():RuleObject=>{
    return {
      pattern:/^[a-zA-Z\.\,\?\<\>\-\_\——\=\;\@\!\+\$]+$/,
      message:'只能输入字母和英文字符'
    }
  },
  number: ():RuleObject=> {
    return {
      pattern: /^\d*$/,
      message: '只能输入数字'
    }
  }
}

export { validators }
